<template>
  <div class="price-index">
    <div class="module-title">产品价格指数-细分</div>
    <div class="border-bg price-container">
      <div class="echart-container" ref="priceChartRef">
      </div>
      <div class="index-cate">
        <span v-for="(item, i) in indexDataList" :key="item.code" :class="{'active': i === activeIndex}" @click="changeIndex(i)">{{item.name}}</span>
      </div>
    </div>

  </div>
</template>

<script setup>
import * as echarts from 'echarts'
import { onMounted, ref, markRaw, computed, watch } from 'vue'
import { useStore } from 'vuex'

// vuex
const store = useStore()
// 数据图chart
const priceChart = ref({})
// 数据图ref
const priceChartRef = ref()
// 指数分类数据
const indexDataList = ref([])
// 当前激活的指数
const activeIndex = ref(null)
// 数据图定时器
const chartTimer = ref(null)
// 指数数据切换定时器
const timer = ref(null)

/** 从vuex中获取指数数据 */
const indexData = computed(() => {
  return {
    index: [...store.getters.index]
  }
})

const filterIndexData = (data, id) => {
  data.value.index.forEach(item => {
    if (item.id === id) {
      indexDataList.value = item.children
    }
  })
}

/** 展示图表 */
const setChart = (data) => {
  priceChart.value = markRaw(echarts.init(priceChartRef.value))
  priceChart.value.clear()
  const option = {
    tooltip: {
      trigger: "axis",
    },
    grid: {
      top: 50,
      left: 50,
      bottom: 30,
      right: 50
    },
    legend: {
      itemWidth: 12,
      right: 15,
      top: 10,
      textStyle: {
        color: '#fff',
        fontSize: 11
      }
    },
    xAxis: [
      {
        type: 'category',
        data: data.xData.slice(-4),
        axisTick: {
          show: false
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: 'rgba(255, 255, 255, 0.5)'
          }
        }
      }
    ],
    yAxis: [
      {
        type: 'value',
        name: '',
        axisTick: {
          show: false
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: 'rgba(255, 255, 255, 0.5)'
          }
        },
        splitLine: {
          lineStyle: {
            color: 'rgba(255, 255, 255, 0.5)'
          }
        },
        axisLabel: {
          show: true
        },
        max: 120,
        min: 40
      },
      {
        type: 'value',
        name: '',
        axisTick: {
          show: false
        },
        splitLine: {
          show: false
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: 'rgba(255, 255, 255, 0.5)'
          }
        },
        max: 120,
        min: 40
      }
    ],
    series: [
      {
        name: '总指数',
        data: data.yData.slice(-4),
        type: 'bar',
        barWidth: '40%',
        animationDelay: function (idx) {
          return idx * 500
        },
        itemStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: 'rgba(129, 235, 247, 0.9)'
              },
              {
                offset: 1,
                color: 'rgba(44, 96, 159, 0.6)'
              }
            ],
            globalCoord: false
          }
        },
        label: {
          normal: {
            show: true,
            position: 'top',

            fontSize: 12,
            color: '#fff',
            offset: [0, 0]
          }
        }
      },
      {
        name: '环比',
        yAxisIndex: 1,
        data: data.last.slice(-4),
        type: 'line',
        symbol: 'triangle',
        symbolSize: 15,
        symbolOffset: [0, -5],
        lineStyle: {
          color: 'rgba(255, 50, 50, 1)',
          width: 2,
          type: 'dashed'
        },
        itemStyle: {
          color: 'yellow',
          borderColor: '#fff',
          borderWidth: 1
        }
      }
    ]
  }
  priceChart.value.setOption(option)
  chartTimer.value && clearInterval(chartTimer.value)
  chartTimer.value = setInterval(() => {
    priceChart.value.clear()
    priceChart.value.setOption(option)
  }, 5000)
}

/** 切换指数 */
const changeIndex = (index) => {
  activeIndex.value = index
}

/** 指数切换定时器 */
const indexChangeTimer = () => {
  const len = indexDataList.value.length
  timer.value && clearInterval(timer.value)
  timer.value = setInterval(() => {
    activeIndex.value++
    activeIndex.value = activeIndex.value % len
  }, 10000)
}

onMounted(() => {
  /** 监听指数数据 */
  watch(() => indexData, (newVal, oldVal) => {
    if (newVal.value.index.length > 0) {
      filterIndexData(newVal, 540)
      activeIndex.value = 0
      indexChangeTimer()
    }
  }, { deep: true, immediate: true })

  /** 监听激活的activeIndex */
  watch(() => activeIndex, (newVal, oldVal) => {
    if (newVal.value !== null) {
      setChart(indexDataList.value[newVal.value].data)
    }
  }, { deep: true, immediate: true })
})

</script>

<style lang="scss" scoped>
.price-index {
  .price-container {
    height: 242px;

    .echart-container {
      height: 100%;
    }
  }
}
</style>
